import { Render, withContentValidation } from '@9gustin/react-notion-render'
import classNames from 'classnames'
import { useState } from 'react'
import { MdInfoOutline } from 'react-icons/md'

import type { ReactElement } from 'react'
import type { ENGINE_TYPE, IEngineTab } from '~/types/arbitration'

import Button from '~/components/Buttons/Button'
import { useNotionPageQuery } from '~/components/ChangeLogModal/queries'
import Modal from '~/components/Modal'
import { ModalBody } from '~/components/Modal/Layout'
import MwMLoader from '~/components/MwMLoader'
import ToggleList from '~/components/Notion/ToggleList'
import { NOTION_ARBITRATION_ENGINE_PAGE_ID } from '~/const/notion'

import './styles.scss'

interface Props {
  activeTab: string
  onTabClick: (tabId: ENGINE_TYPE) => void
  tabs: IEngineTab[]
}

const FAQContent = ({ pageId }: { pageId: string }): ReactElement => {
  const { data, isLoading } = useNotionPageQuery(pageId)

  return (
    <ModalBody className="engine-faq-modal__body">
      {isLoading ? (
        <MwMLoader category="item" />
      ) : data ? (
        <Render
          blockComponentsMapper={{
            toggle: withContentValidation((component) => <ToggleList component={component} notionBlock={data} />),
          }}
          blocks={data.results}
          simpleTitles
          useStyles
        />
      ) : null}
    </ModalBody>
  )
}

const EnginePageSelector = ({ activeTab, onTabClick, tabs }: Props): ReactElement => {
  const [isFAQModalOpen, setIsFAQModalOpen] = useState(false)

  const toggleFAQModal = (isOpen: boolean) => () => setIsFAQModalOpen(isOpen)

  return (
    <div className="engine-page-selector">
      <div className="empty-div" />
      <div className="engine-tabs">
        {tabs.map(({ engineType, name }, index) => (
          <div
            className={classNames('engine-tabs__tab', { active: activeTab === engineType })}
            key={index}
            onClick={() => onTabClick(engineType)}
          >
            {name}
          </div>
        ))}
      </div>
      <div className="faq-button">
        <Button onClick={toggleFAQModal(true)} outlined type="button">
          <MdInfoOutline color="#ff5301" size={16} /> FAQ
        </Button>
      </div>
      <Modal className="engine-faq-modal" isOpen={isFAQModalOpen} onCloseModal={toggleFAQModal(false)}>
        <FAQContent pageId={NOTION_ARBITRATION_ENGINE_PAGE_ID} />
      </Modal>
    </div>
  )
}

export default EnginePageSelector
